// 2_components/products_block_swap_images.js
// Replaces Shoptet's hover swap-image with two explicit <img> elements (first +
// second image) per product card, re-running on Shoptet/Luigi/favorites/Raventic
// content loads.

const productsBlockImageWidth = "423";
const productsBlockImageHeight = "423";

export function init() {
	customSwapImages();

	document.addEventListener("ShoptetDOMContentLoaded", function () {
		customSwapImages();
	});

	document.addEventListener("ShoptetDOMPageMoreProductsLoaded", function () {
		customSwapImages();
	});

	document.addEventListener("luigiSearchDone", function () {
		customSwapImages();
	});

	document.addEventListener("dkLabFavouriteProductsLoaded", function () {
		customSwapImages();
	});

	document.addEventListener("RAVENTIC SEARCH RESULTS TRANSFORMED", function () {
		customSwapImages();
	});
}

function customSwapImages() {
	const swapImagesProducts = document.querySelectorAll(".products-block .swap-images");
	if (!swapImagesProducts || swapImagesProducts.length === 0) {
		return; // No products found
	}
	swapImagesProducts.forEach((product) => {
		if (product.parentElement.classList.contains("custom-swap-images-added")) {
			return; // Skip if already processed
		}
		product.parentElement.classList.add("custom-swap-images-added");

		const swapImage = product.querySelector(".swap-image");
		if (!swapImage) {
			console.warn("Swap image not found for a product.");
			return;
		}

		const swapImageA = product.querySelector("a.image");
		if (!swapImageA) {
			console.warn("Image link not found for a product.");
			return;
		}

		const customFirstImage = document.createElement("img");
		customFirstImage.classList.add("custom-first-image");
		customFirstImage.src = swapImage.getAttribute("data-src") || swapImage.src || "";
		customFirstImage.setAttribute("data-src", swapImage.getAttribute("data-src") || "");
		customFirstImage.alt = swapImage.alt || "";
		customFirstImage.width = productsBlockImageWidth;
		customFirstImage.height = productsBlockImageHeight;
		customFirstImage.loading = "lazy";
		customFirstImage.fetchPriority = "low";

		const customSecondImage = document.createElement("img");
		customSecondImage.classList.add("custom-second-image");
		customSecondImage.src = swapImage.getAttribute("data-next") || swapImage.src || "";
		customSecondImage.alt = swapImage.alt || "";
		customSecondImage.width = productsBlockImageWidth;
		customSecondImage.height = productsBlockImageHeight;
		customSecondImage.loading = "lazy";
		customSecondImage.fetchPriority = "low";

		swapImage.remove();
		swapImageA.appendChild(customFirstImage);
		swapImageA.appendChild(customSecondImage);
	});
}
